import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible/index'
import 'normalize.css'
import './style/iconfont.css'
import {
  Uploader, Loading, Icon, Toast, Popup, Empty, Swipe,
  SwipeItem, Dialog, Picker, Overlay, RadioGroup, Radio, Pagination, Field
} from 'vant'
import 'vant/lib/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './style/swiper.css'
import 'mand-mobile/lib/mand-mobile.css'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(Uploader)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Empty)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Dialog)
Vue.use(Picker)
Vue.use(Overlay)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Pagination)
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
